module.exports = __webpack_public_path__ + "img/Fieldkit_Panel 01_Final_signal1_sized.4d776420.png";